// const API = "/api/auth";

// export async function login(email, senha) {

//   const res = await fetch(`${API}/login`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json"
//     },
//     body: JSON.stringify({
//       email,
//       senha
//     })
//   });

//   const data = await res.json();

//   if (!res.ok) {
//     throw new Error(data.error || "Erro ao fazer login");
//   }

//   return data;
// }


import { api } from "./api"; // Ajuste o caminho se o arquivo api.js estiver em outra pasta

export async function login(email, senha) {
  try {
    // Como a sua "api" já tem a baseURL "http://localhost:3000/api",
    // basta passar o final da rota.
    const res = await api.post("/auth/login", {
      email,
      senha
    });

    // O Axios já converte o JSON automaticamente e guarda em "res.data"
    return res.data;

  } catch (error) {
    // O Axios captura erros de status HTTP (como 401, 404, 500) automaticamente no catch.
    // Pegamos a mensagem de erro que vem do backend, se existir.
    const mensagemErro = error.response?.data?.error || error.response?.data?.message || "Erro ao fazer login";
    throw new Error(mensagemErro);
  }
}